<template>
  <v-layout fill-height
            align-center
            justify-center
            :class="`${bgColor}`"
            wrap
            @click="show(event)">
            <p v-if="formatDateT(event.StartTime)" class="mb-0 body-2" :class="event.Status==1? 'white--text':'blue-titles'">
              <input type="checkbox" :checked="event.Status==1" name="aa" class="mr-2"/>Peak Hours
            </p>
            <p v-if="!formatDateT(event.StartTime) && event.Status==1" class="mb-0 body-2 font-weight-medium checkedStatus text-xs-center">
              <span>{{event.StartTime | formatDate}}</span>
            </p>
            <p v-else></p>

  </v-layout>
</template>
<script>

import { createNamespacedHelpers } from 'vuex'
import confirmDialog from '@/components/confirmDialog'
import { formatDate } from '@/utils/date.js'
import { getTutorLessonDurationTest } from '@/api/classtable'
import { getNextDate } from '@/utils/date.js'

import { isContinous } from '@/utils/date'
const namespace = 'classSchedule'
const { mapGetters, mapActions } = createNamespacedHelpers(namespace)
export default {
  props: ['info'],
  filters: { 
    formatDate (time) {
      //兼容mac客户端时间错乱
      var isMac = /macintosh|mac os x/i.test(navigator.userAgent) 
      if(isMac){
        let date = time.replace("T"," ").replace(/-/g, "/")
        return formatDate(date, 'hh:mm')
      }else{
        let date = new Date(time)
        return formatDate(date, 'hh:mm')
      }
    }
   },
  watch:{
      
  },
  mounted(){
      var myEvent = new Event('resize');
      window.dispatchEvent(myEvent);
  },
  computed: {
    ...mapGetters(['collection', 'selects']),
    event () {
      return {
        ...this.info.event.extendedProps,
        StartTime: this.info.event.extendedProps.TimeStart,
        EndTime: this.info.event.extendedProps.TimeEnd,
        Status: this.info.event.extendedProps.Status,
        IsBusy: this.info.event.extendedProps.IsBusy
      }
    },
    bgColor () {
      if (this.event.Status === 1) { //已选
        return 'ordered-course'
      }else if(this.event.IsBusy && this.event.Status === 0){
          return 'busy-course'
      }else if (this.event.Status === 0) { //可选课
        return 'optional-course'
      }
      else {
        return ''
      }
    },
    selects () {
      return this.$store.state[namespace].selects
    },
  },
  // 试图在当前日历事件下操作整个日历的数据会使视图的反应变得极其慢
  methods: {
    formatDateT(time){
      //兼容mac客户端时间错乱
      var isMac = /macintosh|mac os x/i.test(navigator.userAgent) 
      if(isMac){
        let date = time.replace("T"," ").replace(/-/g, "/")
        return formatDate(date, 'hh:mm') == "05:30"
      }else{
        let date = new Date(time)
        return formatDate(date, 'hh:mm') == "05:30"
      }
    },
    show (event) {
      if(this.formatDateT(event.StartTime)){
        let setStatus = ''
        if(event.Status === 0){
          //设置全选
          setStatus = 'upBusyTime'
        }
        if(event.Status === 1){
          //设置全不选
          setStatus = 'upBusyTimeCancle'
        }
        this.$store.dispatch(`${namespace}/${setStatus}`, event.TimeStart)
      }else{
        this.$store.dispatch(`${namespace}/upEvents`, event)
      }
    }
  }
}
</script>
<style lang="scss">
  .cursor-defaut {
    cursor: default;
  }
  .aaaaa{
    background: red;
  }
  .current-ordere-course{
    background: #577EE3;
  }
  [data-theme="theme1"] .optional-course{
    background: #ececec ;
  }
  .optional-course{
    background: #fff;
  }
  .ordered-course{
    background: #577EE3;
  }
  .busy-course{
      background: #edf6ff;
  }
  .blue-titles{
    color: #32397A !important
  }
</style>
<style lang="scss">
  .checkedStatus{
      width: 70%;
    span {
      margin-top: 5px;
      color: #fff;
    }
    i {
      color: #3bd6a0;
      float: right;
      width: 24px;
    }
  }
  .default-bonus .material-icons.money-icon{
    color: #577ee3;
    border: 2px solid #577ee3;

  }
  .material-icons.money-icon{
    position: absolute;
    right: 11px;
    top: 11px;
    font-size: 16px;
    border-radius: 50%;
    border: 2px solid #fff;
    height: 16px;
    width: 16px;
    line-height: 16px;
    color: #fff;
  }

</style>
